import { translateFn } from '../../utils/translator.helper';
import {
  ProtectedEntitiesSVE,
  ProtectedEntitiesMDM,
  ProtectedEntitiesContainers,
  Companies,
  ProtectedEntitiesEPS,
} from '@nirvana/shared/constants';

export function translateProtectedEntity(type: number, name: string, isCloud: boolean): string {
  switch (type) {
    case Companies.TYPE_COMPANIES_COLLECTION:
      return translateFn('Companies');
    case Companies.TYPE_COMPANY_NETWORK:
      return translateFn('Network');
    case ProtectedEntitiesEPS.ROOT:
      return translateFn('Computers and Virtual Machines');
    case ProtectedEntitiesSVE.ROOT:
      return translateFn('Cloud Workloads');
    case ProtectedEntitiesMDM.ROOT:
      return translateFn('Mobile Devices');
    case ProtectedEntitiesSVE.VMWARE_COLLECTION:
      return translateFn('VMware Inventory');
    case ProtectedEntitiesSVE.XEN_COLLECTION:
      return translateFn('Citrix Inventory');
    case ProtectedEntitiesSVE.NUTANIX_COLLECTION:
      return translateFn('Nutanix Inventory');
    case ProtectedEntitiesSVE.AZURE_COLLECTION:
      return translateFn('Azure Inventory');
    case ProtectedEntitiesEPS.ACTIVE_DIRECTORY:
    case ProtectedEntitiesMDM.ACTIVE_DIRECTORY:
      return translateFn('Active Directory');
    case ProtectedEntitiesEPS.CUSTOM_GROUPS:
      return isCloud ? translateFn('Computers and Groups') : translateFn('Custom Groups');
    case ProtectedEntitiesSVE.CUSTOM_GROUPS:
    case ProtectedEntitiesMDM.CUSTOM_GROUPS:
      return translateFn('Custom Groups');
    case ProtectedEntitiesContainers.TYPE_COLLECTION:
      return translateFn('Containers');
    case ProtectedEntitiesContainers.TYPE_CUSTOM_GROUPS:
      return translateFn('Custom Container Groups');
    case ProtectedEntitiesEPS.TYPE_EXCLUDED_FOLDER:
    case ProtectedEntitiesSVE.TYPE_EXCLUDED_FOLDER:
    case ProtectedEntitiesMDM.TYPE_EXCLUDED_FOLDER:
      return translateFn('Deleted');
    case ProtectedEntitiesEPS.TYPE_VMWARE_COLLECTION:
      return translateFn('VMware Inventory');
    default:
      return name;
  }
}
